import {CellStyle} from './CellStyle';
import {XlsPivotTotalSubColumnConfiguration} from './XlsPivotTotalSubColumnConfiguration';

export class XlsPivotConfiguration {
conditionalKeyStyleFieldName: string;
conditionalKeyStyles: {[key: string]: CellStyle};
defaultValue: string;
fieldName: string;
showDefaultValue: boolean | null;
sortFieldName: string;
style: CellStyle;
totalSubColumnConfiguration: XlsPivotTotalSubColumnConfiguration;
valueFieldName: string;
}

